import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';

class CheckoutBiotrackFail extends React.Component {

    constructor(props) {
        super(props);

        this.reset = this.reset.bind(this);
    }

    reset() {
        var self = this;

        AjaxPromises.POST(PosEndPoints.BIOTRACK_RESET_TRANSMISSION, UserStore.getApiData({
            TransactionId : this.props.guest.ShipmentId
        })).then(res => {
            if (res.Result) {
                NotificationActions.success('Biotrack Transmission Reset');
                self.props.onReset();
            } else {
                NotificationActions.error('Something went wrong');
            }
        });
    }

    render() {
        var self = this;

        if (!this.props.biotrackFail)
            return null;

        return (
            <div className='checkout-completed'>

                <div className='checkout-biotrack__title'>
                    Biotrack Failed
                </div>

                <div className='checkout-biotrack__txt'>
                    {this.props.biotrackFail}
                </div>

                <div
                    className='checkout-biotrack__reset btn-green'
                    onClick={this.reset}>

                    Reset Transmission
                </div>
            </div>
        );
    }
}

export default CheckoutBiotrackFail;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutBiotrackFail.react.jsx